import { getNumeralDeclension } from '@glow/shared/utils/format';

export function formatServiceCount(count: number) {
  const declension = getNumeralDeclension(count, ['услуга', 'услуги', 'услуг']);
  return `${count} ${declension}`;
}
